import { ProductPrice } from '~/Api/Product';

export default class ProductIdPrice {
	productId: string;

	productPrice: ProductPrice;

	constructor(productId: string, productPrice: ProductPrice) {
		this.productId = productId;
		this.productPrice = productPrice;
	}
}
